export default __webpack_public_path__ + "static/media/dpd-logo.a0b54b6e.gif";